module.exports = __webpack_public_path__ + "static/media/22.996a0193.png";